import { shallowEqual } from 'react-redux';
import { Icon } from '@zillow/constellation-10';
import { IconMailFilled } from '@zillow/constellation-icons';

import { useSelector } from '../../../selectors/useSelector';

import ConnectedModuleCard from '../../ConnectedModuleCard';
import ScreeningPreferencesTextButton from '../../ScreeningPreferencesTextButton';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../styles';

const NoInterestedRenters = () => {
  const {
    isEnabled: isScreeningCriteriaEnabled,
    isSet: isScreeningCriteriaSet,
    dateLastActivatedTimestamp,
  } = useSelector((state) => {
    return {
      listingAlias: state.properties.propertyOverview.listingAlias,
      isEnabled: state.properties.propertyOverview.screeningCriteria.isEnabled,
      isSet: state.properties.propertyOverview.screeningCriteria.isSet,
      dateLastActivatedTimestamp: state.properties.currentProperty.dateLastActivatedTimestamp,
    };
  }, shallowEqual);

  const showScreeningCriteriaCTA = isScreeningCriteriaEnabled && dateLastActivatedTimestamp !== '';

  // Setting screening criteria could help attract more renters to your property.
  // Adjusting your criteria could help attract more renters to your property.

  const bodyPrefix = isScreeningCriteriaSet ? 'Adjusting your' : 'Setting screening';
  const screeningCriteriaBody = `${bodyPrefix} criteria could help attract more renters to your property.`;

  return (
    <ConnectedModuleCard data-testid="EmptyInterestedRentersCard">
      <StyledEmptyStateContainer>
        <StyledIconContainer aria-hidden="true">
          <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconMailFilled />} />
        </StyledIconContainer>

        <EmptyStateTitleText asChild>
          <h4>No leads yet</h4>
        </EmptyStateTitleText>

        {showScreeningCriteriaCTA && (
          <EmptyStateBodyText asChild>
            <p>{screeningCriteriaBody}</p>
          </EmptyStateBodyText>
        )}

        <ScreeningPreferencesTextButton textStyle="body-bold" />
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default NoInterestedRenters;
